export type ICashbackLandingPageResources = typeof CashbackLandingPageResources;

export const CashbackLandingPageResources = {
    whatIsCashback: {
        title: "Czym jest <b>cashback</b>",
        subTitle:
            "Gdy robisz zakupy w sklepach internetowych, <b>część wydanych pieniędzy możesz otrzymać z powrotem</b> - to właśnie cashback. W goodie znajdziesz prawie 600 znanych sklepów internetowych, w których dostaniesz cashback.",
        step1Title: "Zakładasz konto w kilka sekund",
        step1Description:
            "Zarejestruj się w goodie cashback na stronie internetowej lub w aplikacji mobilnej goodie.",
        step2Title: "Wybierasz sklep i kupujesz",
        step2Description:
            "W goodie wybierz sklep i wciśnij <b>„Przejdź do sklepu”</b>, a następnie złóż zamówienie i dokonaj płatności - tak jak zawsze!",
        step3Title: "Otrzymujesz zwrot",
        step3Description:
            "Wysokość zwrotu znajdziesz na Twoim koncie w goodie. Po potwierdzeniu zakupu przez sklep, środki zostaną zaakceptowane do wypłaty.",
        step4Title: "Wypłacasz gotówkę na konto",
        step4Description:
            "<b>Po uzbieraniu min. 21 zł</b> cashbacku możesz zlecić przelew środków na dowolne konto bankowe w Polsce.",
        videoTitle: "Zobacz wideo",
    },
    faqCashback: {
        title: "Cashback - najczęściej <b>zadawane pytania</b>",
        question1: "Jak działają Zwroty za zakupy?",
    },

    categoryList: {
        nameAll: "Wszystkie",
        namePopular: "Popularne",
        nameTechnology: "Technologia",
        nameHealthBeauty: "Zdrowie i uroda",
        nameSportingGoods: "Sport",
        nameServices: "Usługi",
        nameHome: "Dom i ogród",
        nameBaby: "Dziecko",
        nameManFashion: "Moda męska",
        nameWomanFashion: "Moda damska",
        nameGrocery: "Spożywcze",
        nameTravel: "Podróż",
        nameAutomotive: "Motoryzacja",
        nameRestaurants: "Restauracje",
        nameEntertainment: "Rozrywka i nauka",
        namePets: "Dla zwierząt",
        nameInsurance: "Ubezpieczenia",
        nameMarketplace: "Marketplace",
    },

    popularCashbackBrands: {
        title: "<b>Popularne sklepy</b> z cashback",
        subTitle: "Cashback za zakupy odbierzesz w blisko <b>600 sklepach</b> internetowych!",
    },

    discountsSection: {
        title: "<b>Możesz łączyć</b> cashback z promocjami w sklepach",
    },

    goodieAdvantages: {
        title: "<b>Zalety</b> goodie cashback",
    },

    mediaAboutUs: {
        title: "<b>Piszą o nas</b>",
    },

    faqCashbackButton: "Pokaż więcej",

    topSection: {
        registerText: "Zarejestruj się",
        anchorText: "Szczegóły",
        title: "Cashback - <b>zwroty pieniędzy za zakupy</b>",
        subTitle:
            "Rób zakupy w ulubionych sklepach internetowych i otrzymuj zwroty części wydanych pieniędzy.",
    },

    secondRegistrationBanner: {
        title: "Co szkodzi spróbować, skoro <b>można tylko zyskać?</b>",
        registerBtnText: "Chcę spróbować",
    },
};
